/* Independent product-only controller; no homepage selectors or scroll animation. */
if (!customElements.get('object-cinema')) customElements.define('object-cinema', class extends HTMLElement {
  connectedCallback() {
    if (this.cleanup) return;
    this.video = this.querySelector('video'); this.button = this.querySelector('button');
    this.preference = matchMedia('(prefers-reduced-motion: reduce)'); this.connection = navigator.connection;
    this.visible = this.near = this.userPaused = this.loaded = this.pending = this.blocked = this.failed = this.away = false;
    const controller = new AbortController(), options = {signal:controller.signal};
    const update = () => this.update();
    this.video.muted = this.video.defaultMuted = true;
    this.button.addEventListener('click', () => {
      if (!this.allowed()) return;
      this.userPaused = !this.video.paused; this.blocked = false; this.update();
    }, options);
    this.video.addEventListener('playing', () => {
      if (!this.wanted()) this.video.pause(); else this.classList.add('has-frame'); this.sync();
    }, options);
    this.video.addEventListener('pause', () => this.sync(), options);
    this.video.addEventListener('error', () => {
      this.failed = true; this.video.pause(); this.classList.remove('has-frame'); this.sync();
    }, options);
    this.preference.addEventListener('change', update, options);
    this.connection?.addEventListener('change', update, options);
    document.addEventListener('lwk:motionchange', update, options);
    document.addEventListener('visibilitychange', update, options);
    window.addEventListener('pagehide', () => {this.away = true; this.update();}, options);
    window.addEventListener('pageshow', () => {this.away = false; this.update();}, options);
    if ('IntersectionObserver' in window) {
      this.nearObserver = new IntersectionObserver(entries => {this.near = entries[0].isIntersecting; this.update();}, {rootMargin:'200px'});
      this.viewObserver = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .15; this.update();
      }, {threshold:[0,.15]});
      this.nearObserver.observe(this); this.viewObserver.observe(this);
    } else this.failed = true; // Retain the poster instead of running an unobserved loop.
    this.cleanup = () => {controller.abort(); this.nearObserver?.disconnect(); this.viewObserver?.disconnect(); this.video.pause();};
    this.update();
  }
  disconnectedCallback() {this.cleanup?.(); this.cleanup = null;}
  allowed() {return !this.preference.matches && !document.documentElement.classList.contains('static-motion') && !this.connection?.saveData;}
  wanted() {return this.allowed() && this.visible && !document.hidden && !this.away && !this.userPaused && !this.failed;}
  sync() {
    const playing = !this.video.paused;
    this.button.hidden = !this.allowed() || this.failed;
    this.button.setAttribute('aria-label', playing ? this.button.dataset.pause : this.button.dataset.play);
    this.querySelector('[data-object-label]').textContent = playing ? this.button.dataset.pause : this.button.dataset.play;
    this.querySelector('[data-object-symbol]').textContent = playing ? 'Ⅱ' : '▶';
    this.dataset.state = !this.allowed() ? 'poster' : this.failed ? 'unavailable' : playing ? 'playing' : this.userPaused ? 'user-paused' : 'paused';
  }
  update() {
    const allowed = this.allowed();
    // Source URLs stay inert for reduced motion, saved Motion Off and Save-Data.
    this.video.autoplay = this.wanted();
    if (!allowed) {
      this.video.pause(); this.classList.remove('has-frame');
      if (this.loaded) {
        this.video.querySelectorAll('source').forEach(s => s.removeAttribute('src'));
        this.video.load(); this.loaded = false; this.blocked = false; this.failed = false;
      }
    } else if (this.near && !document.hidden && !this.away && !this.loaded && !this.failed) {
      this.video.querySelectorAll('source').forEach(s => {s.src = s.dataset.src;});
      this.video.load(); this.loaded = true;
    }
    if (!this.wanted()) this.video.pause();
    else if (this.loaded && this.video.paused && !this.pending && !this.blocked) this.start();
    this.sync();
  }
  async start() {
    this.pending = true;
    try {await this.video.play();}
    catch (error) {if (error.name !== 'AbortError') this.blocked = true;}
    finally {this.pending = false; if (!this.wanted()) this.video.pause(); this.sync();}
  }
});
